import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import {
  getKeywordToolPage,
  KeywordToolSeoPage,
} from '@/components/astro/new-design-25/SEO/keyword-tool-pages';
import { pdfToAudioSearch } from '@/lib/pdf-to-audio-search';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

const page = getKeywordToolPage('pdf-audio-reader');
if (!page) throw new Error('Missing keyword SEO page: pdf-audio-reader');

export const Route = createFileRoute('/_marketing/_seo/pdf-audio-reader')({
  validateSearch: pdfToAudioSearch,
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title: page.metaTitle,
        description: page.metaDescription,
      }),
    ],
    links: [
      { rel: 'canonical', href: normalizeCanonicalUrl('/pdf-audio-reader') },
    ],
  }),
  component: () => <KeywordToolSeoPage page={page} />,
});
